import { Controller } from '@hotwired/stimulus'

let chartCounter = 0

export default class extends Controller {
  static values = {
    type: String,
    data: String,
    options: { type: String, default: '{}' },
  }

  static classes = ['skeleton']

  connect() {
    const ChartClass = window.Chartkick?.[this.typeValue]
    if (!ChartClass) return

    if (!this.element.id) {
      chartCounter += 1
      this.element.id = `chart-${chartCounter}`
    }

    if (!this.element.style.height) {
      this.element.style.height = '300px'
    }

    try {
      const data = JSON.parse(this.dataValue)
      const options = JSON.parse(this.optionsValue)

      if (this.hasSkeletonClass) {
        this.element.classList.remove(this.skeletonClass)
      }

      this.chart = new ChartClass(
        this.element.id, data, options
      )
    } catch (e) {
      console.error('[chart] Failed to parse data:', e)
    }
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  }
}
